import { useNavigate } from 'react-router-dom';

const projects = [
  {
    title: 'Modern Villa — Interior Refresh',
    type: 'Interior',
    location: 'Thorndon, Wellington',
    before: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/983abb470dc8a1ac7a8d2f703dc8664d.jpeg',
    after: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/c2f7ce94e63936f25ab28104b5049384.jpeg',
  },
  {
    title: 'Heritage Home — Full Exterior',
    type: 'Exterior',
    location: 'Newtown, Wellington',
    before: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/8da3d082d616d87c6b24cc2bdb9f2352.jpeg',
    after: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/97784528e2bbfebf8a30fb6a17e5af5a.jpeg',
  },
  {
    title: 'Spray Finish',
    type: 'Fine Finish',
    location: 'Lower Hutt',
    before: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/8682cde038e157067e5461948ffed10b.jpeg',
    after: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/0d026d7507de6b1f4c7f2c6653c3ecd5.jpeg',
  },
];

export default function ProjectsPreview() {
  const navigate = useNavigate();
  return (
    <section id="projects" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span className="inline-block text-[#2D2D2D] text-sm font-semibold tracking-widest uppercase mb-3">Portfolio</span>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight">Our Work</h2>
            <p className="text-gray-500 mt-3 max-w-lg">
              Real results from real projects. See the transformation we deliver across Wellington & Hutt Valley.
            </p>
          </div>
          <a
            href="/projects"
            onClick={(e) => { e.preventDefault(); navigate('/projects'); }}
            className="flex-shrink-0 inline-flex items-center gap-2 px-6 py-3 border-2 border-[#2D2D2D] text-[#2D2D2D] font-semibold rounded-full whitespace-nowrap hover:bg-[#2D2D2D] hover:text-white transition-all cursor-pointer text-sm"
          >
            View All Projects <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <div
              key={project.title}
              className="rounded-2xl overflow-hidden bg-[#F5F5F5] group cursor-pointer"
              onClick={() => navigate('/projects')}
            >
              {/* Before / After */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={project.after}
                  alt={`${project.title} - After`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="bg-[#2D2D2D] text-white text-xs font-bold px-2.5 py-1 rounded-full">{project.type}</span>
                  <span className="bg-green-500 text-white text-xs font-bold px-2.5 py-1 rounded-full">After</span>
                </div>
              </div>
              {/* Before thumbnail */}
              <div className="relative h-28 overflow-hidden border-t-2 border-dashed border-gray-200">
                <img
                  src={project.before}
                  alt={`${project.title} - Before`}
                  className="w-full h-full object-cover object-top opacity-80"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <span className="bg-white/90 text-gray-700 text-xs font-bold px-3 py-1 rounded-full">Before</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base mb-1">{project.title}</h3>
                <div className="flex items-center gap-1 text-gray-400 text-xs">
                  <i className="ri-map-pin-line text-[#2D2D2D]" />
                  {project.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
